import React from "react";
import styled from "styled-components/macro";
import tuluLogoWhite from "../../images/tuluLogoWhite.png";

const CoverHeader = ({ img, title, subtitle }) => {
  return (
    <MainCont img={img}>
      <Column>
        <Img src={tuluLogoWhite} />
        <HeadLine>{title}</HeadLine>
        <ParaCont>{subtitle}</ParaCont>
      </Column>
    </MainCont>
  );
};

export default CoverHeader;

const MainCont = styled.div`
  font-family: "Lexend", serif;
  background-image: ${(props) =>
    `linear-gradient(to right bottom, #234d5b66, #234d5b66), url(${props.img})`};
  background-size: cover;
  background-position: center;
  height: 1230px;
  width: 1930px;
  display: flex;
  align-items: center;
  flex-direction: row;
  mix-blend-mode: multiply;
  background-blend-mode: multiply;
  padding-bottom: 50px;
`;

const HeadLine = styled.h1`
  color: #fff;
  margin: 20px 0 0;
  white-space: pre-wrap;
  font-size: 80px;
  font-weight: bold;
  font-family: "Lexend", serif;
`;

const ParaCont = styled.div`
  display: flex;
  white-space: pre-wrap;
  flex-direction: column;
  color: white;
  font-size: 25px;
  margin: 20px 0;
  font-family: "DMSans", serif;
`;
const Column = styled.div`
  padding: 40px 80px;
  display: flex;
  flex-direction: column;
  width: 70%;
  position: relative;
  top: 110px;
  left: 40px;
`;

const Img = styled.img`
  width: 250px;
`;
